import React from "react";

function subscriptionSVG(classes: any) {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.9167 7.85419V49.1042C22.9167 50.9276 22.1923 52.6762 20.903 53.9655C19.6137 55.2549 17.865 55.9792 16.0417 55.9792H6.875C5.05164 55.9792 3.30295 55.2549 2.01364 53.9655C0.724329 52.6762 0 50.9276 0 49.1042V7.85419C0 6.03082 0.724329 4.28214 2.01364 2.99283C3.30295 1.70352 5.05164 0.979187 6.875 0.979187H16.0417C17.865 0.979187 19.6137 1.70352 20.903 2.99283C22.1923 4.28214 22.9167 6.03082 22.9167 7.85419Z"
        fill="#232323"
      />
      <path
        d="M48.625 0.979187H34.875C33.0516 0.979187 31.303 1.70352 30.0136 2.99283C28.7243 4.28214 28 6.03082 28 7.85419V25.5C28 27.3234 28.7243 29.0721 30.0136 30.3614C31.303 31.6507 33.0516 32.375 34.875 32.375H48.625C50.4484 32.375 52.1971 31.6507 53.4864 30.3614C54.7757 29.0721 55.5 27.3234 55.5 25.5V7.85419C55.5 6.03082 54.7757 4.28214 53.4864 2.99283C52.1971 1.70352 50.4484 0.979187 48.625 0.979187Z"
        fill="#232323"
      />
      <path
        d="M48.625 36.9792H34.875C33.0516 36.9792 31.303 37.7035 30.0136 38.9928C28.7243 40.2821 28 42.0308 28 43.8542V49.125C28 50.9484 28.7243 52.6971 30.0136 53.9864C31.303 55.2757 33.0516 56 34.875 56H48.625C50.4484 56 52.1971 55.2757 53.4864 53.9864C54.7757 52.6971 55.5 50.9484 55.5 49.125V43.8542C55.5 42.0308 54.7757 40.2821 53.4864 38.9928C52.1971 37.7035 50.4484 36.9792 48.625 36.9792Z"
        fill="#747474"
      />
    </svg>
  );
}

export default subscriptionSVG;
